const AbstractItemRepository = require('@/lib/Items/AbstractItemRepository');
const DataStoreNames = require('@/lib/DataStores/DataStoreNames');
const GiftVoucher = require('./GiftVoucher');

class GiftVoucherRepository extends AbstractItemRepository {
    /**
     * @param {DataStore} dataStore
     * @param {Hydrator} hydrator
     * @param {SyncStateManager} syncStateManager
     * @param {ItemBarcodeRepository} itemBarcodeRepository
     * @param giftVoucherResource
     */
    constructor(
        dataStore,
        hydrator,
        syncStateManager,
        itemBarcodeRepository,
        giftVoucherResource
    ) {
        super(dataStore, hydrator, syncStateManager, itemBarcodeRepository);

        this.giftVoucherResource = giftVoucherResource;
    }

    getEntityClass() {
        return GiftVoucher;
    }

    getEntityName() {
        return 'Gift Voucher';
    }

    getTableName() {
        return DataStoreNames.GIFT_VOUCHERS;
    }

    getResource() {
        return this.giftVoucherResource;
    }
}

module.exports = GiftVoucherRepository;
